module.exports = __webpack_public_path__ + "media/images/valores-a385ef0502aae99a3eeeaf114b5866af.jpg";